/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-slide-toggle[_ngcontent-%COMP%] > label[_ngcontent-%COMP%]{display:flex;flex-direction:row-reverse}"];
export { styles as styles };
